/** 测样与标准乙醇相对差 ≥ 该百分比时，液体参考直接不通过 */
export const ETHANOL_DIFF_PERCENT_LIMIT = 10;

/**
 * 从文件名解析乙醇含量：鉴别号+73.3.txt → "73.3"
 * @param {string} fileName
 * @returns {string|null}
 */
export function parseEthanolFromFileName(fileName) {
  if (!fileName) return null;
  const base = String(fileName).replace(/\.txt$/i, "");
  const idx = base.lastIndexOf("+");
  if (idx < 0) return null;
  const raw = base.slice(idx + 1).trim();
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) ? raw : null;
}

/**
 * 相对差百分比：|测样−标准|/|标准| × 100；无效时返回 null
 * @param {string|number} ychl
 * @param {string|number} bzyc
 * @returns {number|null}
 */
export function calcEthanolDiffPercent(ychl, bzyc) {
  const y = Number(ychl);
  const b = Number(bzyc);
  if (!Number.isFinite(y) || !Number.isFinite(b) || b === 0) return null;
  return (Math.abs(y - b) / Math.abs(b)) * 100;
}

/**
 * 乙醇差异是否达到不通过阈值
 * @param {string|number} ychl
 * @param {string|number} bzyc
 * @param {number} [limit=ETHANOL_DIFF_PERCENT_LIMIT]
 * @returns {{ fail: boolean, diffPct: number|null }}
 */
export function evaluateEthanolDiff(ychl, bzyc, limit = ETHANOL_DIFF_PERCENT_LIMIT) {
  const diffPct = calcEthanolDiffPercent(ychl, bzyc);
  if (diffPct == null) return { fail: false, diffPct: null };
  return { fail: diffPct >= limit, diffPct };
}



// WEBPACK FOOTER //
// ./src/util/ethanolSpectrumGate.js